// extracted by mini-css-extract-plugin
module.exports = {"proof":"_93444fe79c--proof--3WLGr","icon":"_93444fe79c--icon--3wr1g"};